/**
 * Demo Mask - Animation and rendering for face landmarks
 */

import type { NormalizedLandmarks, AnimationPhase } from '../types';
import { CONFIG } from '../config';

/**
 * Pre-computed quad mesh edges for MediaPipe 468-point face mesh.
 */
const QUAD_MESH_EDGES: Array<[number, number]> = [
  [0,37],[0,267],[1,4],[1,19],[2,94],[2,97],[2,164],[2,326],[3,51],[3,196],
  [4,51],[4,281],[5,51],[6,197],[6,351],[7,33],[8,9],[9,151],[9,336],[10,109],
  [10,151],[11,0],[11,12],[11,302],[12,13],[13,312],[14,15],[14,87],[15,16],[15,86],
  [15,316],[16,17],[16,85],[18,17],[19,94],[19,354],[20,60],[20,242],[21,71],[21,162],
  [22,231],[23,22],[23,230],[24,23],[24,110],[24,229],[25,7],[25,130],[26,22],[26,232],
  [27,28],[27,223],[28,56],[28,222],[29,27],[29,30],[29,224],[30,161],[30,225],[31,25],
  [31,111],[31,226],[33,246],[34,139],[34,227],[35,124],[35,143],[35,226],[36,142],[36,205],
  [37,39],[37,167],[38,12],[38,72],[39,40],[39,165],[40,92],[40,185],[41,38],[41,73],
  [42,41],[42,74],[42,183],[43,57],[43,106],[43,146],[43,202],[44,1],[44,45],[44,125],
  [45,4],[46,53],[46,70],[47,100],[47,114],[48,64],[48,219],[49,48],[49,102],[50,101],
  [50,187],[51,134],[52,53],[52,65],[52,105],[53,224],[54,21],[54,68],[55,8],[55,107],
  [56,157],[56,190],[57,61],[57,186],[57,212],[58,172],[59,166],[59,235],[60,75],[60,99],
  [60,166],[61,146],[61,185],[62,76],[62,96],[62,183],[63,53],[63,68],[63,70],[63,105],
  [64,98],[64,235],[65,55],[65,66],[66,69],[67,103],[68,104],[69,67],[69,108],[70,71],
  [70,156],[71,68],[71,139],[72,11],[72,37],[73,39],[73,72],[73,74],[74,40],[74,184],
  [75,59],[75,240],[76,61],[76,77],[76,184],[77,90],[77,146],[78,62],[79,20],[79,218],
  [79,239],[81,41],[81,42],[81,82],[82,13],[82,38],[83,18],[83,84],[83,182],[84,17],
  [84,181],[85,84],[85,180],[86,85],[86,179],[87,86],[87,178],[88,89],[88,95],[89,90],
  [89,96],[89,179],[90,91],[90,180],[91,106],[91,181],[92,165],[92,186],[93,132],[93,137],
  [94,141],[94,370],[95,78],[95,96],[96,77],[97,99],[97,141],[97,167],[98,97],[98,129],
  [98,240],[99,240],[100,120],[101,36],[101,100],[101,119],[102,64],[103,54],[103,104],[104,69],
  [105,66],[105,104],[106,182],[106,204],[107,9],[107,66],[107,108],[109,67],[109,108],[110,25],
  [110,228],[111,35],[111,116],[112,26],[112,233],[112,243],[113,124],[113,225],[114,217],[115,131],
  [115,218],[116,143],[117,111],[117,118],[117,228],[118,50],[119,118],[119,120],[120,121],[121,47],
  [122,6],[122,196],[123,50],[123,116],[123,117],[123,147],[124,46],[125,19],[125,141],[125,241],
  [126,47],[126,217],[127,34],[127,234],[128,114],[128,121],[128,245],[129,102],[129,142],[129,209],
  [130,33],[130,247],[131,48],[131,134],[131,209],[132,58],[133,155],[134,45],[134,198],[135,136],
  [135,169],[135,214],[136,150],[137,123],[137,177],[137,227],[138,135],[138,172],[139,156],[139,162],
  [140,32],[140,176],[142,100],[142,126],[143,34],[143,156],[144,24],[144,163],[145,23],[145,144],
  [146,91],[147,177],[147,187],[147,213],[148,152],[149,176],[150,149],[151,108],[152,377],[153,22],
  [153,145],[154,26],[154,153],[155,112],[155,154],[156,124],[157,173],[158,28],[158,157],[159,27],
  [159,158],[160,29],[160,159],[161,160],[162,127],[163,7],[163,110],[164,0],[164,167],[164,393],
  [165,98],[165,167],[166,79],[166,219],[168,8],[168,122],[168,351],[169,150],[169,170],[170,140],
  [170,149],[171,140],[171,148],[171,208],[172,136],[173,133],[174,114],[174,196],[174,236],[175,152],
  [175,171],[175,199],[176,148],[177,132],[177,215],[178,88],[179,178],[180,179],[181,180],[182,181],
  [184,183],[185,184],[186,185],[187,192],[188,122],[188,128],[188,174],[189,190],[189,244],[190,173],
  [190,243],[192,138],[192,213],[193,55],[193,168],[193,189],[193,245],[194,32],[194,182],[194,204],
  [195,3],[195,5],[195,197],[196,197],[197,419],[198,217],[199,428],[200,18],[200,199],[200,421],
  [201,83],[201,194],[201,200],[201,208],[202,210],[202,212],[203,36],[203,129],[203,165],[204,202],
  [204,211],[205,50],[206,92],[206,203],[206,205],[207,187],[207,205],[208,32],[208,199],[209,49],
  [209,126],[209,198],[210,169],[210,211],[211,32],[211,170],[212,214],[212,216],[213,215],[214,192],
  [214,207],[214,210],[215,58],[215,138],[216,186],[216,206],[216,207],[218,166],[218,220],[219,115],
  [220,45],[220,131],[220,237],[221,55],[221,56],[221,189],[222,65],[222,221],[223,52],[223,222],
  [224,223],[225,46],[225,224],[226,113],[226,130],[227,116],[227,234],[228,31],[229,118],[229,228],
  [230,119],[230,229],[231,120],[231,230],[232,121],[232,231],[233,128],[233,232],[233,244],[234,93],
  [235,219],[236,3],[236,134],[236,217],[237,44],[237,79],[238,20],[238,241],[240,235],[241,237],
  [241,239],[242,99],[242,141],[242,241],[243,133],[243,244],[244,245],[245,122],[246,161],[247,30],
  [247,113],[247,246],[248,195],[248,281],[248,419],[249,390],[250,290],[250,309],[250,462],[251,284],
  [252,253],[252,451],[253,254],[253,450],[254,339],[254,449],[255,249],[255,261],[255,359],[256,252],
  [256,452],[257,258],[257,443],[258,286],[258,385],[258,442],[259,257],[259,444],[260,259],[260,445],
  [262,369],[262,431],[263,249],[264,356],[264,368],[264,372],[264,447],[265,340],[265,353],[266,330],
  [266,371],[268,12],[268,312],[269,267],[270,269],[270,409],[271,268],[271,272],[271,303],[271,311],
  [272,304],[272,407],[273,335],[273,375],[273,422],[274,1],[274,457],[275,4],[275,274],[275,440],
  [276,300],[276,353],[276,445],[277,350],[277,355],[278,279],[278,294],[278,439],[280,411],[280,425],
  [281,5],[283,276],[283,282],[283,293],[284,298],[284,332],[285,8],[285,295],[285,336],[286,384],
  [286,414],[286,441],[287,273],[287,291],[287,410],[288,361],[289,305],[289,392],[289,455],[290,305],
  [290,328],[291,306],[291,409],[292,308],[292,325],[292,407],[293,298],[293,334],[294,327],[294,331],
  [294,455],[295,282],[295,296],[296,299],[296,336],[297,299],[297,338],[298,301],[298,333],[300,293],
  [300,301],[300,383],[301,251],[301,368],[302,267],[302,268],[302,303],[303,269],[303,304],[304,270],
  [304,408],[305,460],[306,292],[306,307],[306,408],[307,320],[307,375],[308,324],[309,392],[309,438],
  [311,272],[312,311],[313,18],[313,314],[313,406],[314,17],[314,315],[314,405],[315,16],[315,316],
  [315,404],[316,317],[316,403],[317,14],[318,319],[318,402],[319,320],[319,403],[320,321],[320,404],
  [321,405],[322,270],[322,391],[323,454],[324,318],[324,325],[325,307],[325,319],[327,326],[327,460],
  [328,326],[329,277],[329,349],[330,280],[330,329],[331,279],[331,358],[332,297],[333,299],[333,332],
  [334,282],[334,296],[334,333],[335,321],[335,406],[335,424],[336,337],[337,151],[337,299],[338,10],
  [338,337],[339,255],[339,390],[340,261],[341,256],[341,453],[341,463],[342,445],[342,467],[343,277],
  [343,437],[344,438],[345,340],[345,447],[346,340],[346,352],[347,280],[347,346],[347,348],[348,330],
  [348,349],[350,349],[350,357],[351,412],[351,419],[352,280],[352,345],[352,366],[352,376],[353,342],
  [353,383],[354,274],[354,461],[355,371],[355,437],[356,389],[357,343],[357,465],[358,327],[358,371],
  [358,429],[359,263],[359,446],[359,467],[360,278],[360,344],[360,363],[360,429],[361,323],[362,398],
  [363,275],[363,281],[363,420],[364,365],[364,367],[364,394],[365,397],[366,323],[366,401],[366,447],
  [367,397],[367,416],[370,326],[370,354],[370,462],[371,329],[372,265],[372,345],[372,383],[373,254],
  [373,374],[374,253],[374,380],[375,291],[375,321],[376,401],[376,433],[377,396],[377,400],[378,379],
  [379,365],[380,252],[380,381],[381,256],[381,382],[382,341],[382,362],[383,368],[384,385],[385,386],
  [386,257],[386,387],[387,259],[387,388],[388,260],[388,466],[389,251],[389,368],[390,373],[391,269],
  [391,327],[391,393],[392,290],[392,439],[393,267],[393,326],[394,379],[394,430],[395,369],[395,378],
  [395,394],[395,431],[396,175],[396,369],[396,428],[397,288],[398,384],[399,343],[399,419],[400,369],
  [400,378],[401,361],[401,435],[402,317],[402,403],[403,404],[404,405],[405,406],[406,418],[407,408],
  [408,409],[409,410],[410,322],[411,376],[412,357],[412,399],[413,414],[413,417],[413,441],[413,464],
  [414,398],[414,463],[416,411],[417,168],[417,285],[417,465],[418,262],[421,313],[421,418],[421,428],
  [422,424],[422,430],[423,266],[423,358],[423,391],[424,418],[424,431],[425,266],[425,427],[426,322],
  [426,423],[426,425],[427,411],[428,262],[429,279],[429,355],[429,420],[430,434],[431,430],[432,287],
  [432,422],[432,434],[432,436],[433,416],[433,435],[434,364],[434,416],[434,427],[435,288],[435,367],
  [436,410],[436,426],[436,427],[437,420],[438,392],[438,440],[439,344],[439,455],[440,360],[440,457],
  [441,285],[441,442],[442,295],[442,443],[443,282],[443,444],[444,283],[444,445],[446,261],[446,265],
  [446,342],[448,261],[448,339],[448,346],[449,347],[449,448],[450,348],[450,449],[450,451],[451,349],
  [452,350],[452,451],[452,453],[453,357],[453,464],[454,356],[454,447],[455,460],[456,248],[456,363],
  [456,399],[456,437],[457,309],[457,461],[458,250],[458,461],[459,309],[460,328],[461,459],[461,462],
  [462,328],[463,362],[464,463],[465,351],[465,464],[466,263],[467,260],[467,466],
];

/**
 * Pre-computed quads for fill animation (416 quads)
 */
const FILLABLE_QUADS: Array<[number, number, number, number]> = [
  [0, 37, 167, 164],[0, 37, 72, 11],[0, 267, 302, 11],[0, 267, 393, 164],
  [37, 39, 165, 167],[37, 39, 73, 72],[267, 269, 303, 302],[267, 269, 391, 393],
  [1, 4, 45, 44],[1, 4, 275, 274],[1, 19, 354, 274],[1, 19, 125, 44],
  [4, 51, 5, 281],[4, 51, 134, 45],[4, 281, 363, 275],[19, 94, 141, 125],
  [19, 94, 370, 354],[2, 94, 141, 97],[2, 94, 370, 326],[2, 97, 167, 164],
  [2, 164, 393, 326],[97, 99, 240, 98],[97, 99, 242, 141],[97, 167, 165, 98],
  [326, 327, 460, 328],[326, 327, 391, 393],[326, 328, 462, 370],[3, 51, 5, 195],
  [3, 51, 134, 236],[3, 196, 174, 236],[3, 196, 197, 195],[5, 195, 248, 281],
  [6, 197, 196, 122],[6, 197, 419, 351],[6, 351, 168, 122],[351, 412, 357, 465],
  [351, 412, 399, 419],[7, 33, 130, 25],[7, 25, 110, 163],[33, 246, 247, 130],
  [8, 9, 336, 285],[8, 9, 107, 55],[8, 55, 193, 168],[8, 168, 417, 285],
  [9, 151, 108, 107],[9, 151, 337, 336],[10, 109, 108, 151],[10, 151, 337, 338],
  [11, 12, 38, 72],[11, 12, 268, 302],[12, 13, 312, 268],[12, 13, 82, 38],
  [14, 15, 86, 87],[14, 15, 316, 317],[15, 16, 85, 86],[15, 16, 315, 316],
  [16, 17, 84, 85],[16, 17, 314, 315],[86, 179, 178, 87],[316, 317, 402, 403],
  [17, 18, 83, 84],[17, 18, 313, 314],[85, 180, 179, 86],[18, 83, 201, 200],
  [18, 200, 421, 313],[354, 461, 462, 370],[20, 60, 99, 242],[20, 60, 166, 79],
  [20, 242, 241, 238],[60, 75, 240, 99],[21, 71, 68, 54],[21, 71, 139, 162],
  [22, 231, 230, 23],[22, 231, 232, 26],[22, 23, 145, 153],[22, 26, 154, 153],
  [23, 230, 229, 24],[23, 24, 144, 145],[24, 110, 228, 229],[24, 110, 163, 144],
  [25, 130, 226, 31],[25, 31, 228, 110],[26, 232, 233, 112],[26, 112, 155, 154],
  [27, 28, 222, 223],[27, 28, 158, 159],[27, 223, 224, 29],[27, 29, 160, 159],
  [28, 56, 157, 158],[28, 56, 221, 222],[56, 157, 173, 190],[56, 190, 189, 221],
  [29, 30, 161, 160],[29, 30, 225, 224],[30, 161, 246, 247],[30, 225, 113, 247],
  [31, 111, 35, 226],[31, 111, 117, 228],[111, 116, 123, 117],[34, 139, 156, 143],
  [34, 139, 162, 127],[34, 227, 116, 143],[34, 227, 234, 127],[35, 124, 113, 226],
  [35, 124, 156, 143],[35, 143, 116, 111],[36, 142, 129, 203],[36, 142, 100, 101],
  [36, 205, 50, 101],[36, 205, 206, 203],[205, 206, 216, 207],[39, 40, 92, 165],
  [39, 40, 74, 73],[38, 72, 73, 41],[38, 41, 81, 82],[40, 92, 186, 185],
  [40, 185, 184, 74],[92, 165, 203, 206],[92, 186, 216, 206],[41, 73, 74, 42],
  [42, 74, 184, 183],[43, 57, 61, 146],[43, 57, 212, 202],[43, 106, 91, 146],
  [43, 106, 204, 202],[57, 61, 185, 186],[57, 186, 216, 212],[106, 182, 194, 204],
  [202, 210, 211, 204],[202, 210, 214, 212],[44, 45, 220, 237],[44, 125, 241, 237],
  [45, 134, 131, 220],[125, 141, 242, 241],[46, 53, 224, 225],[46, 53, 63, 70],
  [46, 70, 156, 124],[46, 124, 113, 225],[70, 71, 139, 156],[47, 100, 120, 121],
  [47, 100, 142, 126],[47, 114, 217, 126],[47, 114, 128, 121],[100, 120, 119, 101],
  [114, 217, 236, 174],[114, 128, 188, 174],[48, 64, 235, 219],[48, 64, 102, 49],
  [48, 219, 115, 131],[48, 49, 209, 131],[64, 98, 129, 102],[64, 98, 240, 235],
  [49, 102, 129, 209],[50, 101, 119, 118],[50, 187, 147, 123],[50, 187, 207, 205],
  [50, 118, 117, 123],[187, 192, 214, 207],[134, 198, 217, 236],[52, 53, 224, 223],
  [52, 53, 63, 105],[52, 65, 66, 105],[52, 65, 222, 223],[54, 68, 104, 103],
  [55, 107, 66, 65],[55, 65, 222, 221],[55, 193, 189, 221],[61, 146, 77, 76],
  [61, 185, 184, 76],[58, 172, 138, 215],[58, 132, 177, 215],[59, 166, 60, 75],
  [59, 166, 219, 235],[59, 235, 240, 75],[62, 76, 77, 96],[62, 76, 184, 183],
  [62, 96, 95, 78],[63, 68, 104, 105],[63, 68, 71, 70],[98, 129, 203, 165],
  [66, 69, 108, 107],[66, 69, 104, 105],[67, 103, 104, 69],[67, 69, 108, 109],
  [77, 90, 89, 96],[77, 90, 91, 146],[90, 91, 181, 180],[79, 218, 220, 237],
  [79, 239, 241, 237],[83, 84, 181, 182],[83, 182, 194, 201],[84, 181, 180, 85],
  [88, 89, 96, 95],[88, 89, 179, 178],[89, 90, 180, 179],[91, 106, 182, 181],
  [93, 132, 177, 137],[93, 137, 227, 234],[120, 121, 232, 231],[119, 120, 231, 230],
  [116, 123, 137, 227],[112, 233, 244, 243],[112, 243, 133, 155],[113, 226, 130, 247],
  [115, 131, 220, 218],[115, 218, 166, 219],[131, 134, 198, 209],[117, 118, 229, 228],
  [118, 119, 230, 229],[121, 128, 233, 232],[122, 196, 174, 188],[122, 168, 193, 245],
  [122, 188, 128, 245],[123, 147, 177, 137],[147, 177, 215, 213],[147, 187, 192, 213],
  [126, 217, 198, 209],[126, 142, 129, 209],[128, 245, 244, 233],[133, 173, 190, 243],
  [135, 136, 150, 169],[135, 136, 172, 138],[135, 169, 210, 214],[135, 214, 192, 138],
  [169, 170, 211, 210],[138, 192, 213, 215],[140, 176, 149, 170],[140, 176, 148, 171],
  [32, 140, 170, 211],[32, 140, 171, 208],[32, 194, 204, 211],[32, 194, 201, 208],
  [148, 152, 175, 171],[152, 377, 396, 175],[149, 150, 169, 170],[168, 351, 465, 417],
  [171, 208, 199, 175],[175, 199, 428, 396],[199, 428, 421, 200],[199, 200, 201, 208],
  [189, 190, 243, 244],[189, 244, 245, 193],[195, 197, 419, 248],[207, 214, 212, 216],
  [248, 281, 363, 456],[248, 419, 399, 456],[249, 390, 339, 255],[249, 255, 359, 263],
  [250, 290, 328, 462],[250, 290, 392, 309],[250, 462, 461, 458],[290, 305, 460, 328],
  [309, 438, 440, 457],[309, 457, 461, 459],[251, 284, 298, 301],[251, 301, 368, 389],
  [284, 298, 333, 332],[252, 253, 450, 451],[252, 253, 374, 380],[252, 451, 452, 256],
  [252, 256, 381, 380],[253, 254, 449, 450],[253, 254, 373, 374],[254, 339, 390, 373],
  [254, 339, 448, 449],[255, 261, 446, 359],[255, 261, 448, 339],[261, 340, 265, 446],
  [261, 340, 346, 448],[256, 452, 453, 341],[256, 341, 382, 381],[257, 258, 385, 386],
  [257, 258, 442, 443],[257, 443, 444, 259],[257, 259, 387, 386],[258, 286, 384, 385],
  [258, 286, 441, 442],[286, 384, 398, 414],[286, 414, 413, 441],[259, 444, 445, 260],
  [259, 260, 388, 387],[260, 445, 342, 467],[260, 388, 466, 467],[262, 369, 395, 431],
  [262, 369, 396, 428],[262, 431, 424, 418],[262, 418, 421, 428],[369, 395, 378, 400],
  [369, 396, 377, 400],[263, 359, 467, 466],[264, 356, 389, 368],[264, 356, 454, 447],
  [264, 368, 383, 372],[264, 372, 345, 447],[265, 340, 345, 372],[265, 353, 342, 446],
  [265, 353, 383, 372],[340, 345, 352, 346],[266, 330, 280, 425],[266, 330, 329, 371],
  [266, 371, 358, 423],[266, 423, 426, 425],[268, 312, 311, 271],[268, 271, 303, 302],
  [269, 270, 304, 303],[269, 270, 322, 391],[270, 409, 408, 304],[270, 409, 410, 322],
  [271, 272, 304, 303],[272, 304, 408, 407],[273, 335, 321, 375],[273, 335, 424, 422],
  [273, 375, 291, 287],[273, 422, 432, 287],[335, 406, 418, 424],[422, 424, 431, 430],
  [422, 430, 434, 432],[274, 457, 440, 275],[274, 457, 461, 354],[275, 440, 360, 363],
  [276, 300, 293, 283],[276, 300, 383, 353],[276, 353, 342, 445],[276, 445, 444, 283],
  [300, 301, 368, 383],[277, 350, 349, 329],[277, 350, 357, 343],[277, 355, 371, 329],
  [277, 355, 437, 343],[350, 357, 453, 452],[355, 371, 358, 429],[355, 437, 420, 429],
  [278, 279, 331, 294],[278, 279, 429, 360],[278, 294, 455, 439],[278, 439, 344, 360],
  [279, 331, 358, 429],[294, 327, 460, 455],[294, 327, 358, 331],[280, 411, 376, 352],
  [280, 411, 427, 425],[280, 330, 348, 347],[280, 347, 346, 352],[411, 416, 434, 427],
  [425, 427, 436, 426],[282, 283, 293, 334],[282, 283, 444, 443],[282, 295, 296, 334],
  [282, 295, 442, 443],[293, 298, 301, 300],[293, 298, 333, 334],[285, 295, 296, 336],
  [285, 295, 442, 441],[285, 417, 413, 441],[287, 291, 409, 410],[287, 410, 436, 432],
  [291, 306, 307, 375],[291, 306, 408, 409],[288, 361, 401, 435],[288, 397, 367, 435],
  [289, 305, 290, 392],[289, 305, 460, 455],[289, 392, 439, 455],[292, 308, 324, 325],
  [292, 325, 307, 306],[292, 407, 408, 306],[327, 358, 423, 391],[296, 299, 333, 334],
  [296, 299, 337, 336],[297, 299, 333, 332],[297, 299, 337, 338],[307, 320, 319, 325],
  [307, 320, 321, 375],[320, 321, 405, 404],[313, 314, 405, 406],[313, 406, 418, 421],
  [314, 315, 404, 405],[315, 316, 403, 404],[318, 319, 403, 402],[318, 319, 325, 324],
  [319, 320, 404, 403],[321, 405, 406, 335],[322, 391, 423, 426],[322, 410, 436, 426],
  [323, 454, 447, 366],[323, 361, 401, 366],[329, 349, 348, 330],[349, 350, 452, 451],
  [341, 453, 464, 463],[341, 463, 362, 382],[342, 467, 359, 446],[343, 437, 456, 399],
  [343, 357, 412, 399],[344, 438, 392, 439],[344, 438, 440, 360],[345, 447, 366, 352],
  [346, 347, 449, 448],[352, 366, 401, 376],[347, 348, 450, 449],[348, 349, 451, 450],
  [357, 465, 464, 453],[376, 401, 435, 433],[376, 433, 416, 411],[360, 363, 420, 429],
  [363, 420, 437, 456],[362, 398, 414, 463],[364, 365, 397, 367],[364, 365, 379, 394],
  [364, 367, 416, 434],[364, 394, 430, 434],[367, 416, 433, 435],[394, 430, 431, 395],
  [378, 379, 394, 395],[413, 414, 463, 464],[413, 417, 465, 464],[427, 434, 432, 436],
];

export const FILLABLE_QUADS_COUNT = FILLABLE_QUADS.length;

/**
 * Region edge configuration for separate alpha control.
 */
const MESH_REGION_EDGES = {
  oval: new Set([
    '356-389', '251-389', '368-389', '251-284', '251-301', '284-298', '284-332', '297-332',
    '332-333', '297-299', '297-338', '10-338', '337-338', '10-109', '10-151', '67-109',
    '108-109', '67-103', '67-69', '54-103', '103-104', '21-54', '54-68', '21-71',
    '21-162', '139-162', '127-162', '127-234', '227-234', '93-234', '93-132', '93-137',
    '58-132', '132-177', '34-127', '58-172', '58-215', '138-172', '136-172', '135-136',
    '136-150', '149-150', '150-169', '149-170', '149-176', '140-176', '148-176', '148-152',
    '148-171', '152-377', '152-175', '377-396', '377-400', '369-400', '378-400', '378-379',
    '378-395', '365-379', '379-394', '364-365', '365-397', '367-397', '288-397', '288-361',
    '288-435', '323-361', '361-401', '323-454', '323-366', '264-356', '356-454', '447-454',
  ]),
  lips: new Set([
    '41-42', '42-74', '42-183', '62-96', '62-183', '73-74', '40-74', '74-184',
    '77-90', '42-81', '88-89', '88-95', '89-90', '89-96', '89-179', '90-91',
    '90-180', '78-95', '95-96', '77-96', '88-178', '183-184', '178-179', '86-179',
    '87-178', '179-180', '14-87', '15-86', '85-86', '86-87', '16-85', '84-85',
    '85-180', '180-181', '14-15', '15-16', '15-316', '14-317', '16-17', '16-315',
    '315-316', '316-317', '316-403', '317-402', '314-315', '315-404', '318-402', '402-403',
    '319-403', '403-404', '320-404', '404-405', '318-319', '318-324', '319-320', '319-325',
    '272-311', '271-272', '272-304', '272-407', '307-320', '320-321', '308-324', '324-325',
    '292-325', '307-325', '292-407', '407-408', '303-304', '268-271', '271-303', '271-311',
    '311-312', '302-303', '269-303', '12-268', '268-312', '268-302', '13-312', '11-302',
    '267-302', '11-12', '12-13', '12-38', '13-82', '0-11', '11-72', '81-82',
    '38-82', '38-72', '38-41', '37-72', '72-73', '41-81', '41-73', '39-73',
    '270-304', '304-408', '291-306', '292-308', '292-306', '306-307', '306-408', '307-375',
    '408-409', '62-76', '61-76', '76-77', '76-184', '77-146', '62-78', '184-185',
  ]),
  leftEye: new Set([
    '7-33', '7-25', '33-246', '33-130', '7-163', '161-246', '246-247', '144-163',
    '110-163', '24-144', '144-145', '23-145', '145-153', '22-153', '153-154', '26-154',
    '154-155', '133-155', '112-155', '133-173', '133-243', '157-173', '173-190', '56-157',
    '157-158', '28-158', '158-159', '27-159', '159-160', '29-160', '160-161', '30-161',
  ]),
  rightEye: new Set([
    '362-398', '362-382', '362-463', '381-382', '341-382', '384-398', '398-414', '286-384',
    '384-385', '258-385', '385-386', '257-386', '386-387', '259-387', '387-388', '260-388',
    '388-466', '263-466', '466-467', '249-390', '249-255', '249-263', '263-359', '339-390',
    '373-390', '254-373', '373-374', '253-374', '374-380', '252-380', '380-381', '256-381',
  ]),
};

function edgeKey(a: number, b: number): string {
  return a < b ? `${a}-${b}` : `${b}-${a}`;
}

function getEdgeRegion(idx0: number, idx1: number): 'oval' | 'lips' | 'leftEye' | 'rightEye' | null {
  const key = edgeKey(idx0, idx1);
  if (MESH_REGION_EDGES.oval.has(key)) return 'oval';
  if (MESH_REGION_EDGES.lips.has(key)) return 'lips';
  if (MESH_REGION_EDGES.leftEye.has(key)) return 'leftEye';
  if (MESH_REGION_EDGES.rightEye.has(key)) return 'rightEye';
  return null;
}

const regionVertices = new Map<number, 'oval' | 'lips' | 'leftEye' | 'rightEye' | 'iris'>();
for (const [a, b] of QUAD_MESH_EDGES) {
  const region = getEdgeRegion(a, b);
  if (region) {
    if (!regionVertices.has(a)) regionVertices.set(a, region);
    if (!regionVertices.has(b)) regionVertices.set(b, region);
  }
}
for (let i = 468; i <= 477; i++) {
  regionVertices.set(i, 'iris');
}

function shuffleArray<T>(array: T[]): T[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

export interface DemoAnimationState {
  phase: AnimationPhase;
  phaseStartTime: number;
  dotOrder: number[];
  dotsRevealed: number;
  dotStartTimes: Map<number, number>;
  lineOrder: number[];
  linesRevealed: number;
  lineStartTimes: Map<number, number>;
  fillOrder: number[];
  fillQuads: Array<{ index: number; opacity: number; startTime: number }>;
  fillProgress: number;
  meshAlpha: number;
  fillAlpha: number;
  paused: boolean;
  pauseTime: number;
  totalPausedTime: number;
}

export function createDemoAnimationState(): DemoAnimationState {
  const pointCount = 468;
  const edgeCount = QUAD_MESH_EDGES.length;

  return {
    phase: 'waiting_for_face',
    phaseStartTime: 0,
    dotOrder: shuffleArray(Array.from({ length: pointCount }, (_, i) => i)),
    dotsRevealed: 0,
    dotStartTimes: new Map(),
    lineOrder: shuffleArray(Array.from({ length: edgeCount }, (_, i) => i)),
    linesRevealed: 0,
    lineStartTimes: new Map(),
    fillOrder: shuffleArray(Array.from({ length: FILLABLE_QUADS_COUNT }, (_, i) => i)),
    fillQuads: [],
    fillProgress: 0,
    meshAlpha: 1.0,
    fillAlpha: 1.0,
    paused: false,
    pauseTime: 0,
    totalPausedTime: 0,
  };
}

export function resetDemoAnimation(state: DemoAnimationState): void {
  const now = performance.now();
  state.phase = 'dots';
  state.phaseStartTime = now;
  state.dotsRevealed = 0;
  state.dotStartTimes.clear();
  state.linesRevealed = 0;
  state.lineStartTimes.clear();
  state.fillQuads = [];
  state.fillProgress = 0;
  state.meshAlpha = 1.0;
  state.fillAlpha = 1.0;
  state.paused = false;
  state.totalPausedTime = 0;

  state.dotOrder = shuffleArray(state.dotOrder);
  state.lineOrder = shuffleArray(state.lineOrder);
  state.fillOrder = shuffleArray(state.fillOrder);
}

export function pauseDemoAnimation(state: DemoAnimationState): void {
  if (!state.paused) {
    state.paused = true;
    state.pauseTime = performance.now();
  }
}

export function resumeDemoAnimation(state: DemoAnimationState): void {
  if (state.paused) {
    state.totalPausedTime += performance.now() - state.pauseTime;
    state.paused = false;
  }
}

function getAdjustedTime(state: DemoAnimationState): number {
  const now = performance.now();
  if (state.paused) {
    return state.pauseTime - state.totalPausedTime;
  }
  return now - state.totalPausedTime;
}

function easeOut(t: number, power: number = 3): number {
  return 1 - Math.pow(1 - t, power);
}

export function calculateOverallProgress(state: DemoAnimationState): number {
  // Weights for phases 1-3 (dots, lines, fill)
  const DOTS_WEIGHT = 20;
  const LINES_WEIGHT = 20;
  const FILL_WEIGHT = 20;
  // Weights for phases 4-6 (hold, fill_fade_out, mesh_fade)
  const HOLD_WEIGHT = 15;
  const FILL_FADE_WEIGHT = 15;
  const MESH_FADE_WEIGHT = 10;

  const now = getAdjustedTime(state);

  switch (state.phase) {
    case 'waiting_for_face':
      return 0;
    case 'dots': {
      const dotsProgress = state.dotsRevealed / state.dotOrder.length;
      return Math.round(dotsProgress * DOTS_WEIGHT);
    }
    case 'lines': {
      const linesProgress = state.linesRevealed / state.lineOrder.length;
      return Math.round(DOTS_WEIGHT + linesProgress * LINES_WEIGHT);
    }
    case 'fill': {
      const fillProgress = state.fillQuads.length > 0
        ? state.fillQuads.filter(q => q.opacity >= CONFIG.fill.targetOpacity * 0.99).length / FILLABLE_QUADS_COUNT
        : 0;
      return Math.round(DOTS_WEIGHT + LINES_WEIGHT + fillProgress * FILL_WEIGHT);
    }
    case 'hold': {
      const elapsed = now - state.phaseStartTime;
      const holdProgress = Math.min(1, elapsed / CONFIG.hold.duration);
      return Math.round(DOTS_WEIGHT + LINES_WEIGHT + FILL_WEIGHT + holdProgress * HOLD_WEIGHT);
    }
    case 'fill_fade_out': {
      const elapsed = now - state.phaseStartTime;
      const fadeProgress = Math.min(1, elapsed / CONFIG.fillFadeOut.duration);
      return Math.round(DOTS_WEIGHT + LINES_WEIGHT + FILL_WEIGHT + HOLD_WEIGHT + fadeProgress * FILL_FADE_WEIGHT);
    }
    case 'mesh_fade': {
      const elapsed = now - state.phaseStartTime;
      const meshFadeProgress = Math.min(1, elapsed / CONFIG.meshFade.duration);
      return Math.round(DOTS_WEIGHT + LINES_WEIGHT + FILL_WEIGHT + HOLD_WEIGHT + FILL_FADE_WEIGHT + meshFadeProgress * MESH_FADE_WEIGHT);
    }
    case 'complete':
      return 100;
    default:
      return 0;
  }
}

export function updateDemoAnimation(state: DemoAnimationState): { overallProgress: number } {
  if (state.paused || state.phase === 'waiting_for_face' || state.phase === 'complete') {
    const progress = calculateOverallProgress(state);
    return { overallProgress: progress };
  }

  const now = getAdjustedTime(state);
  const config = CONFIG;

  switch (state.phase) {
    case 'dots': {
      const dotsToReveal = Math.min(
        state.dotOrder.length,
        state.dotsRevealed + config.dots.perFrame
      );

      for (let i = state.dotsRevealed; i < dotsToReveal; i++) {
        const dotIndex = state.dotOrder[i];
        if (!state.dotStartTimes.has(dotIndex)) {
          state.dotStartTimes.set(dotIndex, now);
        }
      }
      state.dotsRevealed = dotsToReveal;

      if (state.dotsRevealed >= state.dotOrder.length) {
        let allComplete = true;
        for (const dotIndex of state.dotOrder) {
          const startTime = state.dotStartTimes.get(dotIndex);
          if (startTime && now - startTime < config.dots.appearDuration) {
            allComplete = false;
            break;
          }
        }
        if (allComplete) {
          if (now - state.phaseStartTime >= config.lines.delayAfterDots) {
            state.phase = 'lines';
            state.phaseStartTime = now;
          }
        }
      }
      break;
    }

    case 'lines': {
      const linesToReveal = Math.min(
        state.lineOrder.length,
        state.linesRevealed + config.lines.perFrame
      );

      for (let i = state.linesRevealed; i < linesToReveal; i++) {
        const lineIndex = state.lineOrder[i];
        if (!state.lineStartTimes.has(lineIndex)) {
          state.lineStartTimes.set(lineIndex, now);
        }
      }
      state.linesRevealed = linesToReveal;

      if (state.linesRevealed >= state.lineOrder.length) {
        let allComplete = true;
        for (const lineIndex of state.lineOrder) {
          const startTime = state.lineStartTimes.get(lineIndex);
          if (startTime && now - startTime < config.lines.growDuration) {
            allComplete = false;
            break;
          }
        }
        if (allComplete) {
          if (now - state.phaseStartTime >= config.fill.delayAfterLines +
              state.lineOrder.length * (config.lines.growDuration / state.lineOrder.length)) {
            state.phase = 'fill';
            state.phaseStartTime = now;
          }
        }
      }
      break;
    }

    case 'fill': {
      const elapsed = now - state.phaseStartTime;
      const quadsToStart = Math.min(
        state.fillOrder.length,
        Math.floor(elapsed / config.fill.delayBetweenQuads)
      );

      while (state.fillQuads.length < quadsToStart) {
        const idx = state.fillQuads.length;
        state.fillQuads.push({
          index: state.fillOrder[idx],
          opacity: 0,
          startTime: now
        });
      }

      let completedQuads = 0;
      for (const quad of state.fillQuads) {
        const quadElapsed = now - quad.startTime;
        const progress = Math.min(1, quadElapsed / config.fill.fadeInDuration);
        quad.opacity = config.fill.targetOpacity * easeOut(progress);
        if (progress >= 1) completedQuads++;
      }

      state.fillProgress = Math.round((completedQuads / FILLABLE_QUADS_COUNT) * 100);

      if (state.fillQuads.length >= state.fillOrder.length && completedQuads >= state.fillOrder.length) {
        state.phase = 'hold';
        state.phaseStartTime = now;
        state.fillProgress = 100;
      }
      break;
    }

    case 'hold': {
      const elapsed = now - state.phaseStartTime;
      if (elapsed >= config.hold.duration) {
        state.phase = 'fill_fade_out';
        state.phaseStartTime = now;
      }
      break;
    }

    case 'fill_fade_out': {
      const elapsed = now - state.phaseStartTime;
      const progress = Math.min(1, elapsed / config.fillFadeOut.duration);
      state.fillAlpha = 1 - progress;

      if (progress >= 1) {
        state.phase = 'mesh_fade';
        state.phaseStartTime = now;
        state.fillAlpha = 0;
      }
      break;
    }

    case 'mesh_fade': {
      const elapsed = now - state.phaseStartTime;
      const progress = Math.min(1, elapsed / config.meshFade.duration);
      state.meshAlpha = 1 - progress * (1 - config.meshFade.targetAlpha);

      if (progress >= 1) {
        state.phase = 'complete';
        state.meshAlpha = config.meshFade.targetAlpha;
      }
      break;
    }
  }

  return { overallProgress: calculateOverallProgress(state) };
}

export function renderDemoMask(
  ctx: CanvasRenderingContext2D,
  landmarks: NormalizedLandmarks,
  state: DemoAnimationState,
  hideProgress = false
): void {
  const points = landmarks.points;
  if (points.length === 0) return;

  const config = CONFIG;
  const now = getAdjustedTime(state);

  // Draw fill
  if (state.phase === 'fill' || state.phase === 'hold' || state.phase === 'fill_fade_out') {
    ctx.fillStyle = config.fill.color;

    for (const quad of state.fillQuads) {
      if (quad.opacity <= 0) continue;

      const quadData = FILLABLE_QUADS[quad.index];
      if (!quadData) continue;

      const [i0, i1, i2, i3] = quadData;
      if (i0 >= points.length || i1 >= points.length || i2 >= points.length || i3 >= points.length) continue;

      ctx.globalAlpha = quad.opacity * state.fillAlpha;
      ctx.beginPath();
      ctx.moveTo(points[i0].x, points[i0].y);
      ctx.lineTo(points[i1].x, points[i1].y);
      ctx.lineTo(points[i2].x, points[i2].y);
      ctx.lineTo(points[i3].x, points[i3].y);
      ctx.closePath();
      ctx.fill();
    }
  }

  // Draw lines
  const showLines = state.phase !== 'waiting_for_face' && state.phase !== 'dots';
  if (showLines) {
    ctx.strokeStyle = config.mask.lineColor;
    ctx.lineWidth = config.mask.lineWidth;

    for (let edgeIndex = 0; edgeIndex < QUAD_MESH_EDGES.length; edgeIndex++) {
      const [idx0, idx1] = QUAD_MESH_EDGES[edgeIndex];
      if (idx0 >= points.length || idx1 >= points.length) continue;

      const p0 = points[idx0];
      const p1 = points[idx1];

      let lineProgress = 1;
      if (state.phase === 'lines') {
        const startTime = state.lineStartTimes.get(edgeIndex);
        if (!startTime) {
          lineProgress = 0;
        } else {
          const elapsed = now - startTime;
          lineProgress = Math.min(1, elapsed / config.lines.growDuration);
          lineProgress = easeOut(lineProgress, 2);
        }
      }

      if (lineProgress <= 0) continue;

      const region = getEdgeRegion(idx0, idx1);
      let alpha = config.mask.lineAlpha;
      if (region && config.mask.regionAlpha[region] !== undefined) {
        alpha = config.mask.regionAlpha[region];
      }

      ctx.globalAlpha = alpha * state.meshAlpha * lineProgress;

      const endX = p0.x + (p1.x - p0.x) * lineProgress;
      const endY = p0.y + (p1.y - p0.y) * lineProgress;

      ctx.beginPath();
      ctx.moveTo(p0.x, p0.y);
      ctx.lineTo(endX, endY);
      ctx.stroke();
    }
  }

  // Draw dots
  const showDots = state.phase !== 'waiting_for_face';
  if (showDots) {
    ctx.fillStyle = config.mask.lineColor;

    for (let i = 0; i < points.length; i++) {
      const point = points[i];

      let dotVisibility = 1;
      if (state.phase === 'dots') {
        const startTime = state.dotStartTimes.get(i);
        if (!startTime) {
          dotVisibility = 0;
        } else {
          const elapsed = now - startTime;
          dotVisibility = Math.min(1, elapsed / config.dots.appearDuration);
          dotVisibility = easeOut(dotVisibility);
        }
      }

      if (dotVisibility <= 0) continue;

      const region = regionVertices.get(i);
      let alpha = config.mask.lineAlpha;
      if (region && config.mask.regionAlpha[region] !== undefined) {
        alpha = config.mask.regionAlpha[region];
      }

      ctx.globalAlpha = alpha * state.meshAlpha * dotVisibility;

      const dotSize = config.mask.pointSize * dotVisibility;
      ctx.beginPath();
      ctx.arc(point.x, point.y, dotSize, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  // Draw progress text (show during all active phases until complete, unless hidden for screenshot)
  const showProgress = !hideProgress && state.phase !== 'waiting_for_face' && state.phase !== 'complete';
  if (showProgress) {
    const overallProgress = calculateOverallProgress(state);

    let topY = Infinity;
    let centerX = ctx.canvas.width / 2;

    if (points.length >= 468) {
      topY = points[10].y;
      centerX = (points[234].x + points[454].x) / 2;
    } else {
      for (const point of points) {
        if (point.y < topY) topY = point.y;
      }
    }

    ctx.globalAlpha = 1;
    ctx.fillStyle = config.mask.lineColor;
    ctx.save();
    ctx.translate(centerX, topY - 40);
    ctx.scale(-1, 1);
    ctx.font = 'bold 28px monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';
    ctx.fillText(`${overallProgress}%`, 0, 0);
    ctx.restore();
  }

  ctx.globalAlpha = 1;
}

export function renderOvalGuide(ctx: CanvasRenderingContext2D, showWarning: boolean = false): void {
  const { width, height } = ctx.canvas;
  const config = CONFIG.faceTracking;

  const centerX = width / 2;
  const centerY = height / 2;
  const radiusY = height * config.ovalRadiusY;
  const radiusX = radiusY * config.ovalAspectRatio;

  ctx.save();
  ctx.strokeStyle = config.ovalColor;
  ctx.globalAlpha = config.ovalAlpha;
  ctx.lineWidth = 2;

  ctx.beginPath();
  ctx.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, Math.PI * 2);
  ctx.stroke();

  if (showWarning) {
    ctx.scale(-1, 1);
    ctx.translate(-width, 0);
    ctx.fillStyle = config.warningColor;
    // ctx.font = '16px sans-serif';
    ctx.font = '20px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(config.warningText, centerX, centerY + radiusY + 30);
  }

  ctx.restore();
}
